import { fn, INamed, IInfOperation } from '@common/utils';
import UISafe = fn.UISafe;
import resolveToError = fn.resolveToError;
import * as kutils from '../navkendo';
import { NavGridOptions, GetGridOptionSettings } from '@common/navkendo/navgrid';
import { NavDock, NavDockZones } from '../navkendo/navdock';
import { IPageMetaData } from '../nav';
import { GetGridOptions } from '../navkendo';
import { INavReadResult } from '@common/navdata';
import { NavSettingsService } from '@common/services/settingsservice';
import { RWFPreviewDock } from '../PreviewDock';
import * as rwf3 from '@common/rwf';
import { IDocLink } from '@common/preview/preview.d';
import { IRWF3DocLink } from '@common/preview/preview.shared';
import { TMPL_DocDescriptionMainDocBold, GetSelectedRowValues } from '../KWFUtils';
import { CtrWFInstanceAddOnData } from '../CtrWFInstanceAddOnData';
import { DialogService } from '@services/dialogservice';
import { getLogConfigColumns } from '../kendo/templates';
import { GridColumn } from '@common/nav';
import { GetSortedDocs, IFDRW_Zusatzdaten_LuGM, IFDRW_Gebuchte_Auftragspositionen, RwfAutoResolver, RwfBootstrap, GetKWF3ArchivedDocumentUrl, IIAX_WF_Log_Entries_Cpl_Sub, IFDRW_Sales_Search, IFDRW_Purchase_Search, GetKWF3DocumentUrl, IWorkflow_FWF_Instance_Completed, ValidateFileSize, toBase64, IFDRW_WFInstanceCompleted } from '@common/rwf';
import { CompatibilityService } from '@services/compatibilityservice';
//#endregion

// Controller for ArchivedDocument Info
export class CtrlDocumentInfo {
  static $inject = ["$scope", "CompatibilityService", "$timeout", "RwfBootstrap", "NavSettings", "WFInstanceCompletedResult"];
  constructor($scope: ng.IScope & {
    /** Set OnChange on Grid */
        UISelectedDoc: rwf3.IIAX_WF_Archive_Document_Sub | rwf3.IIAX_WF_Documents_Sub
  }, $c: CompatibilityService,
    $timeout: ng.ITimeoutService,
    RwfBootstrap: RwfBootstrap,
    NavSettings: NavSettingsService,
    wfInstanceCompletedResult: INavReadResult<rwf3.IFDRW_WFInstanceCompleted>
  ) {
    const rwf = RwfBootstrap.EnsureResolved();
    // Show busy indicator
    $scope["IsLoading"] = true;
    let NavClient = $c.resolve("NavClient"),
      navUrl = wfInstanceCompletedResult.Client.Url;
    /** Get URL for a Workflow Document : (WOut wfDocId : MainDocument, Supplement Document otherwise */
    var GetDocumentUrl = (wfInstanceId: string, wfDocId?: string) => GetKWF3ArchivedDocumentUrl(wfInstanceId, wfDocId, navUrl);

    /** WFInstanceCompleted MetaData Info */
    var metaData = wfInstanceCompletedResult.Client.MetaData;
    /** WFInstanceCompleted Data */
    var data = $scope["WFInstanceCompletedData"] = wfInstanceCompletedResult.Data;
    // Reconstruct Dummy Item, for PropertyGroup Display (CustProps)
    NavClient.ManaulConstructItem<rwf3.IFDRW_WFInstanceCompleted>({
      PageName : wfInstanceCompletedResult.Client.PageName,
      Keys : {},
      NavUrl : wfInstanceCompletedResult.Client.NavUrl
    }, wfInstanceCompletedResult.Data).then((item) => {
      item.Anchor.Readonly.SetForceAll(true);
      var hasCustProp = [1,2,3,4,5].map(idx => "CustProp" + idx).
          find(custProp => item.MetaData.AllPropsByPath[custProp] || /** && ?? */ !!item.Model[custProp]);
      if(hasCustProp) {
        $scope["CustPropInfo"] = { Item : item };
      }
    });
    if (!data || !metaData)
      throw new Error("Keine Daten vorhanden");

    // Do not use subpage Workflow_Add_Information here : no data
    const ctrlAddonData = new CtrWFInstanceAddOnData($c, wfInstanceCompletedResult.Client.Url, data.ID);
    ctrlAddonData.bind('RefreshData', () => {
      $scope["AddonData"] = ctrlAddonData.GridOptions;
      $scope["ShowAddonData"] = ctrlAddonData.Error || ctrlAddonData.data.length > 0
    });
    ctrlAddonData.RefreshData(data.ID)

    // SetUp User Persistence (Register "$destroy" directly and not in deferreds, otherwise access to Controls not available anymore on save)
    var userSettings = NavSettings.CreateUserSettings(["KWF", "CtrlDocumentInfo"]);
    // Save UserSettings on Destroy of Modal Display
    DialogService.OnDestroy($scope, () => {
      userSettings.Save();
      userSettings = undefined;
    });
    // save UserSetting on Page Navigation as long as scope is alive
    $scope.$on("$destroy", NavSettings.RegisterOnBeforeUnload(() => userSettings.Save(true)));

    const afterReset = () => {
      // Workaround: Show PDF after settings reset
      const navPreview = $scope["navDockPreview"] as NavDock;
      if (typeof navPreview?.trigger === "function") {
        navPreview.trigger('DockMoved')
      }
    };
    $scope["ResetUserSettings"] = () => {
      userSettings.Reset().then(afterReset, afterReset);
    };
    $scope["UploadDocCommand"] =
    {
      Hint: "Dokument Hinzufügen",
      Icon: 'idms_Icon_Add',
      Execute: () => {

        var input = $(` <input type='file' hidden/>`).appendTo(document.documentElement)[0] as HTMLInputElement;
        input.addEventListener('change', async () => {
          input.remove();
          if (input.files.length !== 1) {
            return;
          }
          const grd = ($scope['grdDocOptions'] as kendo.ui.Grid)
          const file: File = input.files[0];
          const dlg = $c.resolve('DialogService');

          ValidateFileSize(file);
          if(!await dlg.ShowConfirm('Das Dokument wird sofort archiviert und kann nicht mehr gelöscht werden?\r\nWollen Sie es wirklich hinzugügen?')) {
            return;
          }

          const reset = () => $scope["IsLoading"] = false;
          $scope["IsLoading"] = true;
          var newItemP = $c.post('infoma.Web.KWF3/UploadArchiveFile?' + fn.EncodeQueryData({
            navUrl: wfInstanceCompletedResult.Client.NavUrl
          }), { wfInstanceId: wfInstanceCompletedResult.Data.ID,
            base64Content: await toBase64(input.files[0]),
            filename: file.name} as any).then(() => {
                return NavClient.Read<IFDRW_WFInstanceCompleted>({
                  NavUrl : wfInstanceCompletedResult.Client.NavUrl,
                  PageName : wfInstanceCompletedResult.Client.PageName,
                  Keys : {
                    ID : wfInstanceCompletedResult.Data.ID
                  }
                });
          }, err => dlg.ShowError(fn.resolveToError(err)));
          newItemP.then(reset, reset);

          var newItem = await newItemP;
          if(newItem && (grd?.dataSource instanceof kendo.data.DataSource)) { // oh my ...
            var doc = newItem.Data.Workflow_Archive_Document_Sub.filter(item => !wfInstanceCompletedResult.Data.Workflow_Archive_Document_Sub.find(s => s.ID == item.ID))[0];
            if(doc) {
              wfInstanceCompletedResult.Data.Workflow_Archive_Document_Sub.push(doc);
              grd.dataSource.add(doc);
            }
          }
        });
        input.click();
      }
    };

    /** Set document of preview dock */
    var Preview = (doclink?: IDocLink) => {
      if (wfInstanceId) {
        var kPreviewDock = <RWFPreviewDock>$scope["navDockPreview"] || <RWFPreviewDock>$("#docinfo_preview").data("kendoNavDock");
        if (kPreviewDock) {
          doclink = doclink || <IRWF3DocLink>{
            WorkflowInstanceID: wfInstanceId,
            ID: undefined,
            IsArchived: true,
            NavUrl: wfInstanceCompletedResult.Client.Url,
            Readonly: true,
            Title: "Hauptdokument",
            Url: wfDoc,
            Extension: "pdf"
          };

          kPreviewDock.SetDocument(doclink);
        }
      }
    };

    // Reset the document of the preview to the wf document
    $scope["ResetPreviewCommand"] = <IInfOperation>{
      Execute: () => Preview()
    };

    // Preview via scope
    $scope["PreviewSelected"] = () => {
      // $timeout: UISelectedDoc might not be set correctly at this time
      $timeout(() => {
                var doc = <rwf3.IIAX_WF_Archive_Document_Sub>$scope.UISelectedDoc;
        if (doc) {
          var docUrl = GetDocumentUrl(wfInstanceId, doc.ID);
          var doclink: IRWF3DocLink = {
            ID: doc.ID,
            WorkflowInstanceID: doc.WorkflowInstanceID,
            NavUrl: navUrl,
            IsArchived: true,
            Title: doc.Description,
            Extension: doc.Extension,
            Url: docUrl,
            Type: doc.Type
          };
          Preview(doclink);
        }
      });
    };

    $scope["DownloadSelected"] = () => {
      // $timeout: UISelectedDoc might not be set correctly at this time
      $timeout(() => {
                var doc = <rwf3.IIAX_WF_Archive_Document_Sub>$scope.UISelectedDoc;
        if (doc) {
          var url = GetKWF3ArchivedDocumentUrl(doc.WorkflowInstanceID, doc.ID, navUrl);
          window.open(url, "_blank");
        }
      });
    }

    // Show amount/sum of Debitor/Kreditor in dock info title
    function updateDockCount(grid: kendo.ui.Grid, dock: NavDock, metaData?: IPageMetaData) {
      if (!(dock && dock instanceof NavDock) || !(grid && grid instanceof kendo.ui.Grid))
        return;

      // Update row count
      var selCount = grid.select().length;
      var allData = grid.dataSource.data();
      var filteredData = grid.dataSource.view();
      var rowCount = allData.length;
      var filteredCount = filteredData.length;
      // Calculate total amount
      var totalAmount = 0;
      filteredData.forEach(row => {
        totalAmount += row["Amount"];
      });
      dock.SetCount(filteredCount, filteredCount != rowCount ? rowCount : undefined);

      // Update amount (if exists)
      var amount = metaData && metaData.PropsByName["Amount"];
      if (amount) {
        var currencyFormat = kutils.NumericFormat[amount.DecimalNumericType];
        var titleInfo = selCount > 0 ?
          "Markiert: " + selCount : "Summe: " + kendo.format(currencyFormat, totalAmount);
        dock.SetTitleInfo(titleInfo);
            }
        }
        // Setup Signature Info from Migrated workflows Scenario
        function RetrieveSignData(kwf2TrackingDoc: rwf3.IIAX_WF_Archive_Document_Sub) {
            // kwf2TrackingDoc = kwf2TrackingDoc || <any>{ WorkflowInstanceID: "111", ID: "222" }
            if (!kwf2TrackingDoc) {
                $scope["SignData"] = false;
                return;
            }
            var signGridOptions: NavGridOptions;
      var showSignData: boolean;
      var params = fn.EncodeQueryData({ wfInstanceId: kwf2TrackingDoc.WorkflowInstanceID, wfDocId: kwf2TrackingDoc.ID, navUrl: rwf.NavUrlInfo.FullUrl });
      $c.get<{ Items: INamed<any>[], Columns: string[] }>("/infoma.Web.KWF3/GetMigrationSignDokInfo?" + params).then(info => {
        userSettings.Add("DocSign", GetGridOptionSettings(signGridOptions, () => showSignData == false ? undefined : $scope["grdSignData"]));
        showSignData = info.data.Items.length > 0;
        var columns = <GridColumn[]>[
          {
            width: 30,
            template: '<span title="Signatur anzeigen" class="idms_Icon idms_Icon_Search idms_HoverIcon" ng-click="SignData.ShowSignature(dataItem)"></span>'
          },
          {
            field: "SignedOk", title: "Signaturstatus", width: "35px", template: (d) => {
              return d.SignedOk ? "<span class='idms_Image16 idms_Image_Ok'></span>" :
                "<span class='idms_Image16 idms_Image_Error'></span>";
            }
          },
          {
            field: "CertificateOK", title: "Zertifikat", width: "35px", template: (d) => {
              return d.CertificateOK ? "<span class='idms_Image16 idms_Image_Ok'></span>" :
                "<span class='idms_Image16 idms_Image_Error'></span>";
            }
          },
          { field: "SignedDate", title: "Datum", width: "240px" },
          { field: "SignedBy", title: "Signiert als", width: "160px" },
          { field: "CertificateFrom", title: "Signiert von", width: "140px" },
        ];
        var hiddenCols = info.data.Columns.filter(item => !fn.FindFirst(columns, c => c.field == item)).map(item => {
          return <GridColumn>{ field: item, title: item.replace(/_/g, " "), width: "120px", hidden: true };
        });
        columns.splice(columns.length, 0, ...hiddenCols);
        signGridOptions = <NavGridOptions>{
          dataSource: kutils.GetGridDataSource(info.data.Items),
          columns: columns, sortable: true, resizable: true, navigatable: true, columnMenu: true, customColMenu: true
        };
        return {
          Items: info.data.Items,
          GridOptions: signGridOptions,
          Error: "",
          ShowSignature: (item) => {
            var title = "Signatur " + (item && item.SignedBy) || "";
            Preview({ RawImageDataBase46: item.PNGData, Extension: "png", Title: title, Url: "" });
          }
        };
      }).then(data => { $scope["SignData"] = showSignData && data; }).then(undefined, err => {
        $scope["SignData"] = {
          Error: resolveToError(err)
        };
      });
    }
    // Debitor
    let clEntryData = data.WF_CL_Entry_Subpage || [],
      clEntryMeta = metaData.PropsByName["WF_CL_Entry_Subpage"],
      debitorOptions = GetGridOptions(clEntryData, clEntryMeta?.ArrayProperties);
    debitorOptions.selectable = "multiple";
    userSettings.Add("DebitorGrid", GetGridOptionSettings(debitorOptions, () => showDebitor && $scope["grdDebitor"]));
    const showDebitor = $scope["ShowDebitor"] = clEntryData.length > 0;

    // Kreditor
    let vlEntryData = data.WF_VL_Entry_Subpage || [],
      vlEntryMeta = metaData.PropsByName["WF_VL_Entry_Subpage"];
    var kreditorOptions = GetGridOptions(vlEntryData, vlEntryMeta?.ArrayProperties);
    kreditorOptions.selectable = "multiple";
    userSettings.Add("KreditorGrid", GetGridOptionSettings(kreditorOptions, () => showKreditor && $scope["grdKreditor"]));
    const showKreditor = $scope["ShowKreditor"] = vlEntryData.length > 0;
    $scope["ShowDebOrKred"] = showKreditor || showDebitor;
    function getEntryGrid() { return <kendo.ui.Grid>(showDebitor ? $scope["grdDebitor"] : $scope["grdKreditor"]); }
    var entryMeta = (showDebitor ? clEntryMeta : vlEntryMeta)?.ArrayProperties;
    var entryOptions = showDebitor ? debitorOptions : kreditorOptions;
    entryOptions.change = e => {
      var selEntryNos = GetSelectedRowValues(getEntryGrid(), "Transaction_No");
      var checkFilter = <kendo.data.DataSourceFilters>{
        logic: "or",
        filters: selEntryNos.map(id => { return { field: "Transaction_No", value: id }; })
      };
      if (JSON.stringify(checkFilter) != glentryOptions.dataSource.filter())
        glentryOptions.dataSource.filter(checkFilter);

      // Update count
      updateDockCount(e.sender, $scope["dock_kreddeb"], entryMeta);
    };
    entryOptions.dataBound = e => {
      // Initial count update
      updateDockCount(e.sender, $scope["dock_kreddeb"], entryMeta);

      // Hide busy indicator (after rendering, because of UI lag)
      $scope["IsLoading"] = false;
    };
    kutils.UpdateGridOptions(entryOptions);

    // Sachposten
    let getGLGrid = _Getter<kendo.ui.Grid>($scope, "grdGlEntry"),
      glEntryData = data.WF_GL_Entry_Subpage || [],
      glEntryProp = metaData.PropsByName.WF_GL_Entry_Subpage,
      glentryOptions = GetGridOptions(glEntryData, glEntryProp?.ArrayProperties);
    glentryOptions.dataBound = e => {
      // Initial count update
      updateDockCount(e.sender, $scope["dock_glentry"], glEntryProp?.ArrayProperties);
    };
    kutils.UpdateGridOptions(glentryOptions);
    glentryOptions.selectable = "multiple";
    userSettings.Add("GlEntryGrid", GetGridOptionSettings(glentryOptions, getGLGrid));

    // Personen
    let pkEntryData = data.WF_PK_Entry_Subpage || [];
    var pkOptions = pkEntryData.length && GetGridOptions(pkEntryData, metaData.PropsByName.WF_PK_Entry_Subpage?.ArrayProperties);
    if (pkOptions) {
      userSettings.Add("PKEntryGrid", GetGridOptionSettings(pkOptions, _Getter<kendo.ui.Grid>($scope, "grdPKEntry")));
      pkOptions.dataBound = (e) => { updateDockCount(e.sender, $scope["dock_personenkonten"]); };
      kutils.UpdateGridOptions(pkOptions);
    }

    // Haushaltsstellenposten
    let hhstEntryData = data.WF_HHST_Entry_Subpage || [];
    var hhstOptions = hhstEntryData?.length && GetGridOptions(hhstEntryData, metaData.PropsByName.WF_HHST_Entry_Subpage?.ArrayProperties);
    if (hhstOptions) {
      userSettings.Add("HHSTEntryGrid", GetGridOptionSettings(hhstOptions, _Getter<kendo.ui.Grid>($scope, "grdHhstEntry")));
      hhstOptions.dataBound = (e) => { updateDockCount(e.sender, $scope["dock_hhst"]); };
      kutils.UpdateGridOptions(hhstOptions);
    }

    // Anlagenposten
    let faEntryData = data.WF_FA_Entry_Subpage;
    var faEntryOptions = faEntryData?.length && GetGridOptions(faEntryData, metaData.PropsByName.WF_FA_Entry_Subpage.ArrayProperties);
    if (faEntryOptions) {
      userSettings.Add("FAEntryGrid", GetGridOptionSettings(faEntryOptions, _Getter<kendo.ui.Grid>($scope, "grdFAEntry")));
      faEntryOptions.dataBound = (e) => { updateDockCount(e.sender, $scope["dock_faentry"]); };
      kutils.UpdateGridOptions(faEntryOptions);
    }

    // Bestellungen
    let orderData = data.RegPurchOrderLinesSub;
    let orderOptions = orderData?.length && GetGridOptions(orderData, metaData.PropsByName.RegPurchOrderLinesSub?.ArrayProperties);
    if (orderOptions) {
      userSettings.Add("OrderGrid", GetGridOptionSettings(orderOptions, _Getter<kendo.ui.Grid>($scope, "grdOrder")));
      orderOptions.dataBound = (e) => { updateDockCount(e.sender, $scope["dock_order"]); };
      kutils.UpdateGridOptions(orderOptions);
    }

    /** Promises that have to be resolved before we Apply User Settings */
    let deferApplyOptions = new Array<PromiseLike<any>>(),
      // Übersicht gebuchte Auftragspositionen

      KAMAPosOptions: NavGridOptions,
      queryKamAPos = data.AccountingMode == rwf3.AccountingMode.Kameral && NavClient.ReadMultiple<IFDRW_Gebuchte_Auftragspositionen>({
        PageName: "FDRW_Gebuchte_Auftragspositionen", PageCount: 0, Constraints: [{ FieldName: "DokID", Value: data.ID }]
      }, navUrl).then(d => {
        KAMAPosOptions = d.Data.length && GetGridOptions(d.Data, d.Client.MetaData);
        if (KAMAPosOptions) {
          userSettings.Add("KAMAPosGrid", GetGridOptionSettings(KAMAPosOptions, _Getter<kendo.ui.Grid>($scope, "grdKAMAPos")));
          KAMAPosOptions.dataBound = e => { updateDockCount(e.sender, $scope["dock_kamapos"]); };
        }
      }, err => {
        KAMAPosOptions = null;
        $c.resolve("DialogService").ShowError(err);
      });
    deferApplyOptions.push(queryKamAPos);

    // Docs
    var docConfigColumns = <INamed<GridColumn>>{
      "Description": { template: TMPL_DocDescriptionMainDocBold }
    };
    const subDocProps = metaData.PropsByName.Workflow_Archive_Document_Sub?.ArrayProperties;
    var docOptions = GetGridOptions(data.Workflow_Archive_Document_Sub, subDocProps, docConfigColumns);
    docOptions.columns.splice(0, 0,
      { width: 35, template: "<span class='idms_Icon idms_Icon_Search idms_HoverIcon' ng-click='PreviewSelected()' title='Dokument in Vorschaufenster anzeigen'></span>" },
      { width: 35, template: "<span class='idms_Icon idms_Icon_Download idms_HoverIcon' ng-click='DownloadSelected()' title='Dokument herunterladen'></span>" },

    );

    docOptions.dataBound = e => {
      // Initial count update
      updateDockCount(e.sender, $scope["dock_docs"], subDocProps);
    };
    kutils.UpdateGridOptions(docOptions);
    userSettings.Add("DocGrid", GetGridOptionSettings(docOptions, _Getter<kendo.ui.Grid>($scope, "grdDocOptions")));

    // Logs
    const logData = data.Workflow_Log_Entries_Cpl_Sub,
      logMetaData = metaData.PropsByName.Workflow_Log_Entries_Cpl_Sub.ArrayProperties,
      logOptions = GetGridOptions(logData, logMetaData, getLogConfigColumns(logMetaData)),
      // Spezialfall : aus RWF2 nach RWF3 migrierte Belege : Protokoll aus XML, wie imKWF2
      showLogGrid = $scope["ShowLogGrid"] = logData && logData.length > 0;

    logOptions.columnMenu = $.extend(logOptions.columnMenu || {}, { filterable: true }); // default filter!
    if (showLogGrid) {
      logOptions.dataBound = e => {
        // Initial count update
        updateDockCount(e.sender, $scope["dock_logs"], metaData.PropsByName.Workflow_Log_Entries_Cpl_Sub.ArrayProperties);
      };
    }
    kutils.UpdateGridOptions(logOptions);

    logOptions.filterable = {}; //{ mode: "row" };
    userSettings.Add("LogGrid", GetGridOptionSettings(logOptions, () => $scope["grdLogOptions"]));

        if (showLogGrid) {
            $scope["ShowLog"] = true;
            $scope["KWF2TrackingUrl"] = "";
            //Set initial filter on type
            let techLogFilter = {
                field: <keyof IIAX_WF_Log_Entries_Cpl_Sub>"Type",
                operator: "eq",
                value: 0 // 0 = fachlich
      };
      const logDs = <kendo.data.DataSource>logOptions.dataSource;
      logDs.filter([techLogFilter]);
      // Action to Toggle the Log Filter
      const actToggleLogFilter = {
        Checked: true,
        Execute: () => {
          actToggleLogFilter.Checked = !actToggleLogFilter.Checked;
          if (!actToggleLogFilter.Checked)
            logDs.filter([]);
          else
            logDs.filter([techLogFilter]);
          actToggleLogFilter.Refresh();
        },
        Icon: { "k-icon": true, "k-i-filter": false, "k-i-filter-clear": true },
        Hint: "",
        Refresh: () => {
          var filter = logDs.filter();
          var checked = actToggleLogFilter.Checked = !!(filter && filter.filters && filter.filters.length > 0);
          actToggleLogFilter.Icon["k-i-filter"] = !actToggleLogFilter.Checked;
          actToggleLogFilter.Icon["k-i-filter-clear"] = actToggleLogFilter.Checked;
          actToggleLogFilter.Hint = checked ? "Alle Einträge anzeigen (Filter lösen)" : "Technische Einträge filtern";
        }
      };

      $scope["LogCommands"] = [actToggleLogFilter];
      actToggleLogFilter.Refresh();
    } else {
      var kwf2TrackingDoc = ((data && data.Workflow_Archive_Document_Sub) || []).filter(item => ((item.Extension || "").toLowerCase().indexOf("xml") >= 0) && ((item.Description || "").toLowerCase() == "infopath"))[0];
      if (kwf2TrackingDoc) {
        var trackingUrl = "./infoma.Web.KWF2/GetTrackingFromUrl?" + fn.EncodeQueryData({ trackingUrl: GetKWF3ArchivedDocumentUrl(kwf2TrackingDoc.WorkflowInstanceID, kwf2TrackingDoc.ID, navUrl) });
      }
      $scope["KWF2TrackingUrl"] = trackingUrl;
      $scope["ShowLog"] = !!trackingUrl;
    };
    RetrieveSignData(kwf2TrackingDoc);

    // Preview workflow doc
    var wfInstanceId = data.ID;
    var wfDoc = GetDocumentUrl(wfInstanceId);

    // LuGM
    var lugmOptions = <kendo.ui.GridOptions>{};

    userSettings.Add("DocLuGM", GetGridOptionSettings(lugmOptions, () => showLuGM == false ? undefined : $scope["grdLuGM"]));
    var showLuGM: boolean;
    // Defer Initialization after LuGm State is determined
    const kwf3Settings = rwf.RwfSetup;
    if (kwf3Settings.LuGMEnabled && !rwf.RwfSettings.User.IsStandalone) {
      deferApplyOptions.push(NavClient.ReadMultiple<IFDRW_Zusatzdaten_LuGM>({
        PageName: "FDRW_Zusatzdaten_LuGM", PageCount: 0,
        Constraints: [{ FieldName: "Transaction_No", Value: data.TransactionNoFilter }]
      }, rwf.NavUrlInfo.FullUrl).then((lugmData) => {
        if (lugmData) {
          lugmOptions.dataBound = lugmOptions.change = e => {
            // Initial count update
            updateDockCount(e.sender, $scope["dock_lugm"], lugmData.Client.MetaData);
          };
          // caution : as options are registered in user settings handling, extend current options ...
          $.extend(lugmOptions, GetGridOptions(lugmData.Data, lugmData.Client.MetaData));
          kutils.UpdateGridOptions(lugmOptions);

          glentryOptions.change = e => {
            var selEntryData = GetSelectedRowValues(getGLGrid(), "Entry_No");
            var checkFilter = <kendo.data.DataSourceFilters>{
              logic: "or",
              filters: selEntryData.map(id => { return { field: "Entry_No_G_L_Entry", value: id }; })
            };
            if (JSON.stringify(checkFilter) != JSON.stringify(lugmOptions.dataSource.filter())) {
              lugmOptions.dataSource.filter(checkFilter);
            }

            // Update count
            updateDockCount(e.sender, $scope["dock_glentry"], metaData.PropsByName["WF_GL_Entry_Subpage"].ArrayProperties);
          };
          showLuGM = $scope["ShowLuGM"] = lugmData.Data && lugmData.Data.length > 0;
        }
      }, err => {
        $c.resolve("DialogService").ShowError(err);
      }));
    } else {
      showLuGM = $scope["ShowLuGM"] = false;
    }

    UISafe($c.all(deferApplyOptions).then(() => {
      // As long as we can Apply DockZones Settings via created Instance Only (and not by Settings Obj)
      // we must wait for DockZones to be Created to apply userSettings
      var dockZonesCreated = (dockZones: NavDockZones) => {
        if (!(dockZones && dockZones instanceof NavDockZones) || !waitCreated)
          return;

        waitCreated();
        waitCreated = undefined;
        userSettings.Add("Layout", () => dockZones.GetSettings(), state => state && dockZones.ApplySettings(state));

        const afterLoad = () => {
          $scope["LogOptions"] = logOptions;
          $scope["DocOptions"] = docOptions;
          $scope["LuGMOptions"] = lugmOptions;
          $scope["GLEntryOptions"] = glEntryData.length && glentryOptions;
          $scope["KreditorOptions"] = kreditorOptions;
          $scope["DebitorOptions"] = clEntryData.length && debitorOptions;
          $scope["PKOptions"] = pkOptions;
          $scope["HHSTOptions"] = hhstOptions;
          $scope["FAOptions"] = faEntryOptions;
          $scope["OrderOptions"] = orderOptions;
          $scope["KAMAPosOptions"] = KAMAPosOptions;
          $scope.$broadcast("DocumentInfoInitialized");
        };
        userSettings.Load().then(afterLoad, afterLoad);
        // Preview is also dependent on HTML
        Preview();
      };

      var waitCreated = $scope.$on("kendoWidgetCreated", () => {
        var dockZones = <NavDockZones>$scope["navDockZones"];
        if (dockZones) {
          dockZonesCreated(dockZones);
        }
      });
      // This is not enough, as kendo exposeWidget does not trigger digest!
      // --> waitCreated
      $scope.$watch("::navDockZones", dockZonesCreated);
    }));
  };

  /** Get Archived Document Info by Doc ID (IFDRW_WFInstanceCompleted) */
  static GetArchivedDocInfo($rwf: RwfAutoResolver, docIdOrEntryNo: string) {
    const $c = $rwf("$c");
    const NavClient = $c.resolve("NavClient");
    return $rwf("RwfBootstrap").Resolve.then((rwf) => {
      var navUrl = rwf.NavUrlInfo.FullUrl,
        wfCompleted = rwf3.Pages.FDRW_WFInstanceCompleted;

      // Load via EntryNo if is number only
      if (/^[1-9][0-9]*$/.test(docIdOrEntryNo))
        var loadEntry = NavClient.ReadMultiple<rwf3.IFDRW_WFInstanceCompleted>({
          PageName: wfCompleted.PageName,
          PageCount: 2,
          Constraints: [{ FieldName: "EntryNo", Value: docIdOrEntryNo }]
        }, navUrl).then(d => d.Data.length == 1 && { Data: d.Data[0], Client: d.Client });
      else
        loadEntry = NavClient.ReadMultiple<rwf3.IFDRW_WFInstanceCompleted>({
          PageName: wfCompleted.PageName,
          PageCount: 2,
          Constraints: [{ FieldName: "ID", Value: docIdOrEntryNo }]
        }, navUrl).then(d => d.Data.length == 1 && { Data: d.Data[0], Client: d.Client });;

      return loadEntry.then(d => {
        if (!d.Data)
          throw new Error("Zu '" + docIdOrEntryNo + "' sind keine Daten vorhanden!");
        return d;
      });
    });
  }

  /** Get Archived Document's Documents Info by Doc ID */
  static GetArchiveDocumentsInfo($rwf: RwfAutoResolver, rowItem: IFDRW_Purchase_Search | IFDRW_Sales_Search | IWorkflow_FWF_Instance_Completed) {
    const docId = rowItem.WorkflowID;
    return CtrlDocumentInfo.GetArchivedDocInfo($rwf, docId).then(d => {
      var instance = <rwf3.IFDRW_WFInstanceCompleted>d.Data;
      var GetDocumentUrl = (wfInstanceId: string, wfDocId?: string) =>
        GetKWF3ArchivedDocumentUrl(wfInstanceId, wfDocId, d.Client.Url);

      return GetSortedDocs((instance && instance.Workflow_Archive_Document_Sub) || []).map(item => {
        return <IRWF3DocLink>{
          ID: item.ID,
          WorkflowInstanceID: item.WorkflowInstanceID,
          IsArchived: true,
          AllowEdit: false,
          NavUrl: d.Client.NavUrl,
          Title: item.Description,
          Added: item.Added,
          ContentType: item.Type.toString(),
          Extension: item.Extension,
          Type: item.Type,
          Url: GetDocumentUrl(docId, item.ID)
        };
      });
    });
  }
}

/** Build Getter Function by property Name */
function _Getter<T>($scope: any, name: string) { return () => $scope ? <T>$scope[name] : <T>undefined; }
